import React from 'react';
import { Box, Typography, Divider, Paper, Button } from '@mui/material';
import closeIcon from '../../../assets/icons/closeIcon.svg';

export const AddOnInfoModal = ({ onClose }: { onClose: () => void }) => {
  return (
    <Box
      sx={{
        maxWidth: 400,
        borderRadius: '0.9375rem',
        position: 'absolute',
        top: '50%',
        left: '50%',
        transform: 'translate(-50%, -50%)',
        display: 'flex',
        flexDirection: 'column'
      }}
      component={Paper}
    >
      <Box
        sx={{
          display: 'flex',
          flexDirection: 'column',
          padding: '1rem 1rem 0 1rem'
        }}
      >
        <Button
          onClick={onClose}
          sx={{ padding: 0, marginLeft: 'auto', minWidth: 0 }}
        >
          <img src={closeIcon} alt="Close" />
        </Button>
        <Box sx={{ display: 'flex', paddingTop: '0.625rem' }}>
          <Typography
            align="center"
            sx={{
              fontFamily: 'Calibri',
              fontSize: '1rem',
              fontWeight: 700,
              lineHeight: '1.25rem',
              color: '#002A3A'
            }}
          >
            REE
          </Typography>
          <Typography
            align="center"
            sx={{
              fontFamily: 'Calibri',
              fontSize: '1rem',
              fontWeight: 400,
              lineHeight: '1.25rem',
              color: '#002A3A'
            }}
          >
            {` = Resting Energy Expenditure`}
          </Typography>
        </Box>
        <Box sx={{ display: 'flex', paddingTop: '0.625rem' }}>
          <Typography
            sx={{
              fontFamily: 'Calibri',
              fontSize: '1rem',
              fontWeight: 700,
              lineHeight: '1.25rem',
              color: '#002A3A'
            }}
          >
            PAL
            <span
              style={{
                fontFamily: 'Calibri',
                fontSize: '1rem',
                fontWeight: 400,
                lineHeight: '1.25rem',
                color: '#002A3A'
              }}
            >
              {` = Physical Activity Level`}
            </span>
          </Typography>
        </Box>
        <Box sx={{ display: 'flex', paddingTop: '0.625rem' }}>
          <Typography
            sx={{
              fontFamily: 'Calibri',
              fontSize: '1rem',
              fontWeight: 700,
              lineHeight: '1.25rem',
              color: '#002A3A'
            }}
          >
            EFSA
            <span
              style={{
                fontFamily: 'Calibri',
                fontSize: '1rem',
                fontWeight: 400,
                lineHeight: '1.25rem',
                color: '#002A3A'
              }}
            >
              {` = European Food Safety Authority`}
            </span>
          </Typography>
        </Box>
      </Box>
      <Box sx={{ padding: '0.9375rem' }}>
        <Divider sx={{ width: '100%' }} />
        <Typography
          align="left"
          sx={{
            fontFamily: 'calibri',
            fontSize: '1rem',
            fontStyle: 'italic',
            fontWeight: 700,
            color: '#004F71',
            paddingTop: '1.25rem'
          }}
        >
          Reference:
        </Typography>
        <Typography
          align="left"
          sx={{
            fontFamily: 'calibri',
            fontSize: '1rem',
            fontWeight: 400,
            lineHeight: '1.25rem',
            color: '#004F71'
          }}
        >
          {`EFSA Panel on Dietetic Products, Nutrition and Allergies (NDA); Scientific Opinion on Dietary Reference Values for energy. EFSA Journal 2013;11(1):3005. [112 pp.] doi:10.2903/j.efsa.2013.3005. Available online:www.efsa.europa.eu/efsajournal`}
        </Typography>
      </Box>
    </Box>
  );
};
